import { Outlet } from 'react-router-dom'
import React, {useEffect, useState} from 'react';
import { NavBar } from '@commons/Componentes/Navbars/Navbar';
import { SideBar } from '@commons/Componentes/Sidebar/SideBar';
import { useTheme,useAuthentication } from "@commons/Hooks";
import {getComponentWithLoading} from "../../Commons/Scripts/Utils";

function Layout ({showLoading, hideLoading}){
    const {theme} = useTheme();
    const {usuario} = useAuthentication();
    useEffect(() => {
        const navbar = document.querySelector("#NavBar");
        document.addEventListener("click", function (event) {
            if (!navbar.contains(event.target) ) {
                let DropdownTrigger = navbar.querySelector('.show.dropdown.nav-item')
                if(DropdownTrigger){
                    DropdownTrigger.click()
                }
            }
        });
    }, []);
    
    return (
        <div className="bootstrapiso" style={{opacity: usuario ? 1 : 0}}>
            <div className="wrapper">
                    <div id="sidebar" className="sidebar" style={{
                        backgroundImage: `linear-gradient(${theme?.color1},${theme?.color2} 150%)`,
                        zIndex: '900002'
                    }}>
                        <SideBar />
                    </div>
                <div className="main-panel">
                    <div id='navPanel' style={{
                        position: 'sticky',
                        top: '0',
                        height: '70px',
                        zIndex: '900001'
                    }}>
                        <div className='bootstrapiso' style={{height:"inherit"}}>
                            <div id="NavBar" className="navbar navbar-expand-lg navbar-light bootstrapiso" style={{
                                borderBottom: '1px solid rgba(0, 0, 0, .1)',
                                maxHeight: '71px',
                                minHeight: '71px',
                                paddingLeft: '0px',
                                paddingRight: '0px',
                            }}>
                                <NavBar />
                            </div>
                            {usuario?.Compania.Configuracion.Mensaje && (
                                <marquee style={{
                                    color: usuario.Compania.Configuracion.ColorMensaje ? `#${usuario.Compania.Configuracion.ColorMensaje}` : '#FF0000',
                                    zIndex: '900014',
                                    top: 50,
                                    position: 'absolute'
                                }} id="mqId" behavior="scroll" direction="left">{usuario.Compania.Configuracion.Mensaje}</marquee>
                            )}
                        </div>
                    </div>
                        <Outlet />
                </div>
            </div>
        </div>
    )
}

export const App = React.memo(getComponentWithLoading(Layout));
